import { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { API_URL_FILE, BASE_URL, IMG_USER_URL } from "../Utils/constants";

const SideBar = () => {
  const img_url_default = "/dist/";
  const user = useSelector((state) => state.auth);
  const [search, setSearch] = useState("");

  return (
    <>
      {/* Main Sidebar Container */}
      {/* <aside
        className={`main-sidebar  elevation-4 ${
          theme === "light" ? "sidebar-light-primary" : "sidebar-dark-primary"
        }`}
      > */}
      <aside className={`main-sidebar  elevation-4 sidebar-dark-primary`}>
        {/* Brand Logo */}
        <NavLink to="/" className="brand-link">
          <img
            src={BASE_URL + "/logo.jpeg"}
            alt="Logo"
            className="brand-image img-circle elevation-3"
            style={{ opacity: ".8" }}
          />
          <span className="brand-text font-weight-light">GAPIENA</span>
        </NavLink>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar user panel (optional) */}
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              <img
                src={
                  user?.img &&
                  ((user?.img.split("/")).length > 1
                    ? BASE_URL + img_url_default
                    : `${API_URL_FILE}/${IMG_USER_URL}`) + user?.img
                }
                className="img-circle elevation-2"
                alt={user.lastname}
                style={{ height: "2.1rem" }}
              />
            </div>
            <div className="info">
              <NavLink to="profile" className="d-block">
                {user &&
                  user.firstname?.split(" ")[0].charAt(0).toUpperCase() +
                    user.firstname?.split(" ")[0].slice(1)}{" "}
                {user.lastname?.toUpperCase()}
              </NavLink>
            </div>
          </div>
          {/* SidebarSearch Form */}
          <div className="form-inline">
            <div className="input-group" data-widget="sidebar-search">
              <input
                className="form-control form-control-sidebar"
                type="search"
                name="search"
                id="search"
                placeholder="Search"
                aria-label="Search"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
              />
              <div className="input-group-append">
                <button className="btn btn-sidebar">
                  <i className="fas fa-search fa-fw" />
                </button>
              </div>
            </div>
          </div>
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
              <li className="nav-item ">
                <NavLink to="/" className="nav-link">
                  <i className="nav-icon fas fa-tachometer-alt" />
                  <p>Dashboard</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/applications" className="nav-link ">
                  <i className="nav-icon fas fa-desktop" />
                  <p>Applications</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/messages" className="nav-link ">
                  <i className="nav-icon fas fa-envelope" />
                  <p>Messages</p>
                </NavLink>
              </li>
              {user.roles && user.roles?.includes("ROLE_ADMIN") && (
                <li className="nav-item">
                  <NavLink to="/utilisateurs" className="nav-link ">
                    <i className="nav-icon fas fa-users" />
                    <p>Utilisateurs</p>
                  </NavLink>
                </li>
              )}
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </>
  );
};

export default SideBar;
